export default "__VITE_ASSET__BsfjXFjR__"